import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'news-center',
  templateUrl: './news-center.component.html',
  styleUrls: ['./news-center.component.scss']
})
export class NewsCenterComponent implements OnInit {
  pageContent: SafeHtml = '';
  loading = true;

  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    const url = `${environment.newsStaticUrl}/news-center.html`;
    this.http.get(url, { responseType: 'text' }).subscribe({
      next: (html) => {
        // 将图片相对路径替换为绝对路径，避免 [innerHTML] 渲染时基于当前页面 URL 解析
        const fixedHtml = html.replace(
          /(<img\s[^>]*?\bsrc=")images\//g,
          `$1${environment.newsStaticUrl}/images/`
        );
        this.pageContent = this.sanitizer.bypassSecurityTrustHtml(fixedHtml);
        this.loading = false;
      },
      error: () => {
        this.pageContent = '<p style="color:#999;text-align:center;padding:3rem;">内容加载失败</p>';
        this.loading = false;
      }
    });
  }
}
